import * as React from "react";
import { cn } from "~/lib/utils";
import IconsSprite from "../../images/icons-sprite.svg";
import { iconsList } from "./iconsList";

export type IconName = (typeof iconsList)[number];
export interface IconProps extends React.HTMLAttributes<SVGSVGElement> {
  name: IconName;
  size?: number;
  label?: string;
  decorative?: boolean;
}

export const Icon: React.FC<IconProps> = React.forwardRef<
  SVGSVGElement,
  IconProps
>(
  (
    {
      name,
      size = 24,
      className,
      label,
      decorative = false,
      ...rest
    }: IconProps,
    ref,
  ): React.ReactNode => {
    const baseAttributes = (): React.SVGProps<SVGSVGElement> => {
      const attributes: React.SVGProps<SVGSVGElement> = {};
      if (label) attributes["aria-label"] = label;
      if (decorative && !label) attributes["aria-hidden"] = true;
      return attributes;
    };

    if (!iconsList.includes(name)) {
      if (process.env.NODE_ENV === "development") {
        throw new Error(`${name} is not a known icon`);
      }
      return "";
    }

    return (
      <svg
        ref={ref}
        className={cn("fui-icon", className)}
        width={size}
        height={size}
        data-testid={`${name}-icon`}
        {...baseAttributes()}
        {...rest}
      >
        <use href={`${IconsSprite}#${name}`} />
      </svg>
    );
  },
);
